import avatar from "../../../assets/img/unknown_person.jpg";

const initialState = {
  disableBtn: false,
  isLoading: false,
  rerender: false,
  packages: [],
  companyTags: [],
  stepsBack: -1,
  countries: [],
  rerenderList: false,
  rerenderSubscription: false,
  showPaymentPlans:false,
  companyDetails: {},
  subscriptionInfo: {
    isProPackage: false,
    isFinished: false,
    noActivePlan: false,
    isYearly: false,
    isFree: false,
  },
  userInfo: {},
  mediaIdReset: [],
  isAuthenticated: true,
  layerOptions: [],
  selectedApp: {},
  assign: false,
  layer: "MAIN",
  addContentSource: "main",
  layerSettingsTab: "display",
  type: "media",
  isPrayerCampaign: false,
  hideTabs: false,
  campaignDetails: { total_duration: 0 },
  isPublished: false,
  selectedMediaInfo: {},
  deletedItemId: "",
  previewMode: false,
  profileImage:
    localStorage.getItem("image") === "null"
      ? avatar
      : localStorage.getItem("image"),
  showAssignForm: false,
  openDialog: {
    // Shared component (Add content dialog)
    assignScheduleCampaigns: false,
    takeOverScreen: false,
    assignCampaignsDropDown: false,
    campaignConflictDialog: false,
    GroupAssignCampaignsDropDown: false,
    assignDeviceGroup: false,
    addContent: false,
    screenshot: false,
    // Media-Folder
    moveMediaFolder: false,
    uploadToPlaylist: false,
    deleteMediaDialog: false,
    // Folder
    createFolder: false,
    updateFolder: false,
    // Media
    previewMedia: false,
    uploadMedia: false,
    updateMedia: false,
    // Campaign
    editInteractiveMedia: false,
    usageAndConfirmation: false,
    campaignSettings: false,
    layerSettings: false,
    screenSettings: false,
    campaignMediaSetting: false,
    createCampaign: false,
    updateCampaign: false,
    resetCampaign: false,
    playlistSettingPopup: false,
    layoutConflict: false,
    playlistMediaPreview: false,

    // Device
    createGroupDialog: false,
    analyticsDialog: false,
    analyticsDetailDialog: false,
    warnActionDialog: false,
    logMessage: false,
    stopConfirmation: false,
    downloadProgress: false,
    confirmDialog: false,
    assignDialog: false,
    updateDevice: false,
    orderDialog: false,
    devicePreview: false,
    deviceSettings: false,

    //Playlist
    updatePlaylist: false,
    tagDialog: false,
    createPlaylist: false,
    // Broadcast
    createBroadcastDialog: false,
    // Billing
    paymentDialog: false,
    addScreens: false,
    upgrade: false,
    membership_plans: false,
    // Users
    addUser: false,
    // Apps
    rssFeedAddition: false,
    rssCreation: false,
    customRssCreation: false,
    streamPreview: false,
    addCustomFeed: false,
    createEditCollection: false,
    addCollectionContent: false,
  },
  subLoaders: {
    // Interactive campaign
    durationLoader: false,
    titleLoader: false,
    thumbLoading: false,
    // Broadcast App
    createLoading: false,
    streamsLoading: true,
    reload: false,
    // Campaign Media
    deleteCampaignMedia: false,
    // Billing
    packageDetails: false,
    invoicePreview: false,
    subscriptions: false,
    calculatePrice: true,
    packages: false,
    addScreens: false,
    // Company
    isFree: false,
  },
  deleteDialog: {
    interactiveCampaign: false,
    playlist: false,
    campaign: false,
    device: false,
    folder: false,
    media: false,
    user: false,
  },
};

export default initialState;
